import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { getApiSettings } from './api';
import { request } from '@vfde-fe/sails_core';

import {
    SEND_WEBCHAT_MESSAGE,
} from './constants';
import {
    sendWebchatMessageSuccess,
    sendWebchatMessageFailed,
} from './actions';

import {
    SendMessageConfig,
} from './api';

import getApiPath from 'Helper/getApiPath';

import {
    selectWebchatConfigUserId,
    selectWebchatConfigAlias,
    selectWebchatConfigSecureKey,
    selectWebchatConfigChatId,
} from 'Container/InitWebchat/selector';
import {TRACKING_WEBCHAT_ERROR_MESSAGE_NOT_AVAILBLE} from 'Container/Tracking/constants';
import { selectMessage } from './selector';
import { selectWebchatPath } from 'Container/Ui/selector';

/**
 * sendMessage
 */
export function* sendMessage () {
    try {

        const [userId, alias, secureKey, chatId, message, webchatPath] =
        yield all ([
            select(selectWebchatConfigUserId()),
            select(selectWebchatConfigAlias()),
            select(selectWebchatConfigSecureKey()),
            select(selectWebchatConfigChatId()),
            select(selectMessage()),
            select(selectWebchatPath()),
        ]);

        const data: SendMessageConfig = {
            userId: userId,
            alias: alias,
            secureKey: secureKey,
            message: message,
            messageType: 'text',
        };

        const apiSettings = getApiSettings(data);

        const apiPath = getApiPath(chatId, 'send', webchatPath);

        const response = yield call(request, apiPath, apiSettings);

        // create and yield a dispatch Effect
        yield put(sendWebchatMessageSuccess());
    } catch (error) {
        yield put(sendWebchatMessageFailed(true, error?.res?.status || TRACKING_WEBCHAT_ERROR_MESSAGE_NOT_AVAILBLE));
    }

  }

/**
 *  sendMessageSaga
 */
export default function* sendMessageSaga () {
    yield takeLatest(SEND_WEBCHAT_MESSAGE, sendMessage);
}
